<div class="payment" [ngClass]="status">
  <div class="payment__left">
    <img src="assets/icons/clock-orange.svg" *ngIf="status === 'pending'" />
    <img src="assets/icons/clock-gray.svg" *ngIf="status === 'disabled'" />
    <img src="assets/icons/check_green.svg" *ngIf="status === 'success'" />
  </div>
  <div class="payment__right">
    <div class="payment__right__installment">
      <div class="count">{{ count }}/{{ total }}</div>
      <div class="amount">{{ amount }}</div>
    </div>
    <div class="payment__right__date">
      <div class="today" *ngIf="count === 1">HOY</div>
      <div class="other" *ngIf="count !== 1">
        {{ date | dayName }}
        <br />
        {{ date | date : 'd MMM, y' | uppercase }}
      </div>
    </div>
  </div>
</div>
